import {ActionLink} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const LearnerAppLink = (context: NavigationContext): ActionLink => ({
    type: 'actionLink',
    label: 'navigation.learner_app',
    link: context.learnerApp.link,
    action: context.learnerApp.action,
    icon: 'navigation-link__learner-app',
});